import { useQuery } from '@tanstack/react-query';

import { getAccessAdmins } from '@/api/auth/get-access-admins';

import { authKeys } from './query-keys';

/** Names of the people to ask for access, for someone who holds no role and so no permission. */
export const useAccessAdmins = () =>
  useQuery({ queryKey: authKeys.accessAdmins(), queryFn: getAccessAdmins, retry: false });
